import { useAtomValue } from "jotai";
import {
  HAMBURGER_MENU_MARGIN,
  NavProfileSidePanel,
} from "../Navigation/NavProfileSidePanel/NavProfileSidePanel";
import {
  hamburgerMenuHeightAtom,
  showTopNavAtom,
} from "../../../atoms/navAtoms";
import { darkModeAtom } from "../../../atoms/user/darkModeAtom";

export const HamburgerMenu = () => {
  const showHeader = useAtomValue(showTopNavAtom);
  const hamburderMenuHeight = useAtomValue(hamburgerMenuHeightAtom);
  const darkMode = useAtomValue(darkModeAtom);

  return (
    <NavProfileSidePanel
      darkMode={darkMode}
      additionalSxProps={(theme) => ({
        boxShadow: "var(--box-shadow-header-size-and-color)",
        top: showHeader
          ? `${HAMBURGER_MENU_MARGIN}px`
          : `${(hamburderMenuHeight + HAMBURGER_MENU_MARGIN) * -1}px`,
        zIndex: theme.zIndex.customZIndex.topNav,
        position: "fixed",
        transition: ".3s ease",
      })}
    />
  );
};
